import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ChatGPT from './ChatGPT';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChatGPT />
  </React.StrictMode>
);
